import { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import type { NewsEntry } from './DevopsNewsPage';

const REFRESH_MS = 5 * 60_000;

/** Franja arriba de todas las páginas mientras haya un freeze o aviso vigente. */
export const ActiveNoticeBanner = () => {
  const discovery = useApi(discoveryApiRef);
  const { fetch } = useApi(fetchApiRef);
  const [notices, setNotices] = useState<NewsEntry[]>([]);

  useEffect(() => {
    const load = async () => {
      const res = await fetch(`${await discovery.getBaseUrl('devops-news')}/active`);
      if (res.ok) setNotices(await res.json());
    };
    load().catch(() => undefined);
    const timer = setInterval(() => load().catch(() => undefined), REFRESH_MS);
    return () => clearInterval(timer);
  }, [discovery, fetch]);

  if (!notices.length) return null;
  return (
    <div>
      {notices.map(n => (
        <Typography
          key={n.id}
          component="div"
          style={{ padding: '8px 24px', background: n.kind === 'freeze' ? '#c62828' : '#f9a825', color: n.kind === 'freeze' ? '#fff' : '#000' }}
        >
          <b>{n.kind === 'freeze' ? 'Freeze' : 'Aviso'}:</b> {n.title} — {n.description}{' '}
          {n.ends_at && `(hasta ${new Date(n.ends_at).toLocaleString('es-EC', { dateStyle: 'medium', timeStyle: 'short' })})`}{' '}
          <Link to="/devops-news" style={{ color: 'inherit', textDecoration: 'underline' }}>Ver detalle</Link>
        </Typography>
      ))}
    </div>
  );
};
